import { render, staticRenderFns } from "./Individuals.vue?vue&type=template&id=3df7fda4&scoped=true"
import script from "./Individuals.vue?vue&type=script&lang=js"
export * from "./Individuals.vue?vue&type=script&lang=js"
import style0 from "./Individuals.vue?vue&type=style&index=0&id=3df7fda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7fda4",
  null
  
)

export default component.exports